module.exports = __webpack_public_path__ + "img/tracking-delivered.e4b9ec6e.png";